import * as React from 'react';
import {Mutation} from 'react-apollo';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
import {SavedSettingToast} from 'shells/saved-setting-toast/saved-setting-toast';

import type {
    SetCalendarSyncImportIsEnabled as SetCalendarSyncImportIsEnabledMutation,
    SetCalendarSyncImportIsEnabledVariables as SetCalendarSyncImportIsEnabledMutationVariables,
    CalendarSync as CalendarSyncFragment,
} from 'nutshell-graphql-types';

import SET_CALENDAR_SYNC_IMPORT_IS_ENABLED from './graphql/mutations/set-calendar-sync-import-is-enabled.graphql';
import {getComponentKey} from './helpers';
import {updateCacheFromMutation} from './update-cache-from-mutation';

class SetCalendarSyncImportIsEnabled extends Mutation<
    SetCalendarSyncImportIsEnabledMutation,
    SetCalendarSyncImportIsEnabledMutationVariables
> {}

type Props = {
    calendarSync: CalendarSyncFragment;
    disabled: boolean;
};

export function CalendarImportRadioGroup(props: Props) {
    const [valueSaved, setValueSaved] = React.useState<boolean | null | undefined>(null);
    const savedTimeoutRef = React.useRef();

    const componentKey = React.useRef<string>(getComponentKey());

    const {isEnabled, importIsEnabled} = props.calendarSync;

    return (
        <SetCalendarSyncImportIsEnabled mutation={SET_CALENDAR_SYNC_IMPORT_IS_ENABLED}>
            {(setCalendarSyncImportIsEnabled, {loading: mutationIsRunning}) => {
                const disabled = mutationIsRunning || !isEnabled || props.disabled;

                return (
                    <RadioGroup
                        name={`calendar-import-${componentKey.current}`}
                        selectedValue={importIsEnabled ? '1' : '0'}
                        size='big'
                        onChange={(setIsEnabled) => {
                            setCalendarSyncImportIsEnabled({
                                variables: {
                                    calendarSync: {
                                        importIsEnabled: setIsEnabled === '1',
                                    },
                                },
                                update: updateCacheFromMutation,
                            }).then((mutationResult) => {
                                setValueSaved(
                                    // @ts-expect-error
                                    mutationResult &&
                                        mutationResult.data &&
                                        mutationResult.data.setCalendarSyncImportIsEnabled &&
                                        mutationResult.data.setCalendarSyncImportIsEnabled
                                            .calendarSync &&
                                        mutationResult.data.setCalendarSyncImportIsEnabled
                                            .calendarSync.importIsEnabled
                                );
                                if (savedTimeoutRef.current) {
                                    clearTimeout(savedTimeoutRef.current);
                                }
                                // @ts-expect-error
                                savedTimeoutRef.current = setTimeout(() => {
                                    setValueSaved(null);
                                }, 1000);
                            });
                        }}
                    >
                        <SavedSettingToast state={valueSaved === true ? 'complete' : 'initial'}>
                            <Radio value='1' disabled={disabled}>
                                Yes, create activities in Nutshell for events added to my calendar
                            </Radio>
                        </SavedSettingToast>
                        <SavedSettingToast state={valueSaved === false ? 'complete' : 'initial'}>
                            <Radio value='0' disabled={disabled}>
                                No, don&apos;t import from my calendar
                            </Radio>
                        </SavedSettingToast>
                    </RadioGroup>
                );
            }}
        </SetCalendarSyncImportIsEnabled>
    );
}
